import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import ScrollReveal from "../../components/feature/ScrollReveal";
import { Link } from "react-router-dom";

const sections = [
  {
    title: "体験予約",
    links: [
      { label: "トップページ", href: "/" },
      { label: "横浜ヘリクルージング", href: "/yokohama" },
      { label: "料金・プラン", href: "/pricing" },
      { label: "ギフトチケット", href: "/gift" },
    ],
  },
  {
    title: "ご利用ガイド",
    links: [
      { label: "初めての方へ", href: "/first-time" },
      { label: "FAQ", href: "/faq" },
      { label: "アクセス", href: "/access" },
      { label: "持ち込み制限", href: "/baggage" },
      { label: "当日の流れ", href: "/flow" },
      { label: "ご予約の流れ", href: "/booking-flow" },
      { label: "キャンセルポリシー", href: "/cancel-policy" },
    ],
  },
  {
    title: "AIRDOAについて",
    links: [
      { label: "運営会社", href: "/company" },
      { label: "コラム", href: "/column" },
      { label: "お客様の声", href: "/reviews" },
      { label: "お知らせ", href: "/news" },
    ],
  },
  {
    title: "サポート",
    links: [
      { label: "お問い合わせ", href: "/contact" },
      { label: "プライバシーポリシー", href: "/privacy" },
      { label: "特定商取引法に基づく表記", href: "/tokushoho" },
    ],
  },
];

const heroData = {
  label: "SITEMAP",
  title: "サイトマップ",
  subtitle: "AIRDOAの全ページを一覧でご案内します。目的のページを見つけやすく整理しています。",
  image:
    "https://readdy.ai/api/search-image?query=Minimalist%20aerial%20view%20of%20organized%20geometric%20grid%20pattern%2C%20soft%20warm%20lighting%2C%20deep%20navy%20blue%20and%20cream%20color%20palette%2C%20abstract%20architectural%20lines%2C%20calm%20and%20orderly%20composition%2C%20no%20text%2C%20high%20quality%20illustration&width=1920&height=600&seq=sitemaphero01&orientation=landscape",
};

export default function Sitemap() {
  return (
    <PageLayout>
      <InfoPageHero
        label={heroData.label}
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="サイトマップ"
      />

      <section className="py-14 md:py-20 bg-airdoa-white">
        <div className="px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
              {sections.map((section, idx) => (
                <ScrollReveal key={section.title} direction="up" delay={idx * 80}>
                  <div>
                    <h2 className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-4">
                      {section.title}
                    </h2>
                    <ul className="flex flex-col gap-2.5">
                      {section.links.map((link) => (
                        <li key={link.href}>
                          <Link
                            to={link.href}
                            className="text-sm text-airdoa-gray hover:text-airdoa-navy transition-colors duration-200"
                          >
                            {link.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <InfoPageFinalCTA
        title={`目的のページが\n見つかりませんでしたか？`}
        subtitle="お気軽にお問い合わせください。スタッフが丁寧にご案内いたします"
        ctas={[
          { label: "お問い合わせページへ", href: "/contact", type: "primary" },
          { label: "FAQを見る", href: "/faq", type: "secondary" },
        ]}
      />

      <InfoPageFooter />
    </PageLayout>
  );
}
